/* eslint-disable no-underscore-dangle */
import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import EntrantsApp from "../entrants";

const contentData = window.asos.ldp.state;

delete window.asos.ldp.state;

const start = async () => {
  loadableReady(() => {
    hydrateRoot(
      document.getElementById("react-root"),
      <EntrantsApp contentData={contentData} />
    );
  });
};

start();
